const UserDelete = {
  data: function () {
    return {
      loading: false,
    };
  },
  computed: {
    user() {
      return domestiko.user;
    },
  },
  methods: {
    submit: function () {
      this.loading = true;
      axios
        .post('/usuarios/cerrar-cuenta/', {
          user: this.user._id,
        })
        .then((res) => {
          customAlert(
            'Solicitud recibida.',
            'Te hemos enviado un correo para verificar tu baja.',
          );
        })
        .catch((err) => {
          //console.log('Request KO!', err.response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  template: `
      <div class="user-delete">
	      <div class="uk-margin-top">
	        	<button
			        @click="submit()"
			        class="uk-button uk-button-dmtk"
		        >Darse de baja</button>
	      </div>
      </div>
	`,
};
